'use client';

import { VariantProps } from 'class-variance-authority';
import { cn } from 'lib/cn';
import {
    DateField as AriaDateField,
    DateInput as AriaDateInput,
    DateInputProps as AriaDateInputProps,
    DateSegment as AriaDateSegment,
    DateSegmentProps as AriaDateSegmentProps,
    composeRenderProps
} from 'react-aria-components';
import { inputContainerClassNames } from '~/components/ui/Form/StyledInput';

const DateField = AriaDateField;

function DateSegment({ className, ...props }: AriaDateSegmentProps) {
    return (
        <AriaDateSegment
            className={composeRenderProps(className, (composedClassName) =>
                cn(
                    props.segment.type === 'literal' ? 'tw-px-0' : 'tw-inline tw-rounded tw-p-0 tw-px-1',
                    'tw-inline tw-rounded tw-caret-transparent tw-outline tw-outline-0',
                    /* Placeholder */
                    'data-[placeholder]:tw-text-accents-6',
                    /* Disabled */
                    'data-[disabled]:tw-cursor-not-allowed data-[disabled]:tw-opacity-50',
                    /* Focused */
                    'data-[focused]:tw-text-accent-foreground data-[focused]:tw-bg-accents-3',
                    /* Invalid */
                    'data-[invalid]:data-[focused]:tw-bg-destructive data-[invalid]:data-[focused]:data-[placeholder]:tw-text-destructive-foreground data-[invalid]:data-[focused]:tw-text-destructive-foreground data-[invalid]:data-[placeholder]:tw-text-destructive data-[invalid]:tw-text-destructive',
                    composedClassName
                )
            )}
            {...props}
        />
    );
}

interface DateInputProps extends AriaDateInputProps, VariantProps<typeof inputContainerClassNames> {}

function DateInput({ className, size, isInvalid, disabled, bordered, ...props }: Omit<DateInputProps, 'children'>) {
    return (
        <AriaDateInput
            className={composeRenderProps(className, (composedClassName) =>
                cn(
                    inputContainerClassNames({ size, isInvalid, disabled, bordered }),
                    'tw-justify-start tw-gap-0 tw-rounded-e-none tw-border-accents-0',
                    composedClassName
                )
            )}
            {...props}
        >
            {(segment) => <DateSegment segment={segment} />}
        </AriaDateInput>
    );
}

// interface JollyDateFieldProps<T extends AriaDateValue> extends AriaDateFieldProps<T> {
//     label?: string;
//     description?: string;
//     errorMessage?: string | ((validation: AriaValidationResult) => string);
// }

// function JollyDateField<T extends AriaDateValue>({
//     label,
//     description,
//     className,
//     errorMessage,
//     ...props
// }: JollyDateFieldProps<T>) {
//     return (
//         <DateField
//             className={composeRenderProps(className, (className) =>
//                 cn('tw-group tw-flex tw-flex-col tw-gap-2', className)
//             )}
//             {...props}
//         >
//             <Label>{label}</Label>
//             <DateInput />
//             {description && (
//                 <Text className="tw-text-muted-foreground tw-text-sm" slot="description">
//                     {description}
//                 </Text>
//             )}
//             <FieldError>{errorMessage}</FieldError>
//         </DateField>
//     );
// }

// interface JollyTimeFieldProps<T extends AriaTimeValue> extends AriaTimeFieldProps<T> {
//     label?: string;
//     description?: string;
//     errorMessage?: string | ((validation: AriaValidationResult) => string);
// }

// function JollyTimeField<T extends AriaTimeValue>({
//     label,
//     description,
//     errorMessage,
//     className,
//     ...props
// }: JollyTimeFieldProps<T>) {
//     return (
//         <TimeField
//             className={composeRenderProps(className, (className) =>
//                 cn('tw-group tw-flex tw-flex-col tw-gap-2', className)
//             )}
//             {...props}
//         >
//             <Label>{label}</Label>
//             <DateInput />
//             {description && <Text slot="description">{description}</Text>}
//             <FieldError>{errorMessage}</FieldError>
//         </TimeField>
//     );
// }

// export { JollyDateField, JollyTimeField, TimeField}
// export type { JollyDateFieldProps, JollyTimeFieldProps }

export { DateField, DateInput, DateSegment };
export type { DateInputProps };
